import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-add-view',
  templateUrl: './client-add-view.component.html',
  styleUrls: ['./client-add-view.component.css']
})
export class ClientAddViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
